import './SearchBox.less'
import React from 'react'
import Autosuggest from 'react-autosuggest'
import SearchResult from './SearchResult'
import _ from 'underscore'

class SearchBox extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      value: '',
      hoveredSuggestion: {}
    }
    this.getSuggestionValue = this.getSuggestionValue.bind(this)
    this.renderSuggestion = this.renderSuggestion.bind(this)
    this.debouncedLoadSuggestions = _.debounce(this.loadSuggestions, this.props.debounce || 100)
    this.handleClick = this.handleClick.bind(this)
    this.handleKeyPress = this.handleKeyPress.bind(this)
    this.onKeyDown = this.onKeyDown.bind(this)
  }

  onChange = (event, { newValue, method }) => {
    if (method === 'escape') {
      this.props.closeSearch('escape')
    } else {
      this.setState({
        value: newValue
      })
    }
  }

  onBlur = (event) => {
    if (event && event.nativeEvent && event.nativeEvent.sourceCapabilities) {
      this.props.closeSearch('escape')
    }
  }

  onKeyDown (event) {
    if (event && event.nativeEvent && event.nativeEvent.code === 'Escape') {
      this.props.closeSearch('escape')
    }
  }

  onSuggestionsFetchRequested = ({ value }) => {
    this.debouncedLoadSuggestions(value)
  }

  onSuggestionsClearRequested = () => {
    this.props.onSuggestionsClearRequested()
    this.props.closeSearch()
  }

  handleClick (suggestion) {
    suggestion.callback()
    this.props.closeSearch(suggestion)
  }

  handleKeyPress (event) {
    if (event.key === 'Enter' &&
      this.state.hoveredSuggestion &&
      Object.keys(this.state.hoveredSuggestion).length > 0 &&
      this.state.hoveredSuggestion.callback &&
      this.props.closeSearch) {
      this.state.hoveredSuggestion.callback()
      this.props.closeSearch(this.state.hoveredSuggestion)
    }
  }

  renderSuggestion (suggestion, { query }) {
    return (<SearchResult title={suggestion.title}
      description={suggestion.description}
      img={suggestion.icon}
      onClick={() => this.handleClick(suggestion)} />)
  }

  getSuggestionValue (suggestion) {
    this.setState({
      hoveredSuggestion: suggestion
    })
    return this.state.value
  }

  loadSuggestions (value) {
    this.props.requestSuggestions(value)
  }

  componentDidUpdate () {
    this.input.focus()
  }

  storeInputReference = autosuggest => {
    if (autosuggest !== null) {
      this.input = autosuggest.input
    }
  }

  render () {
    const { value } = this.state
    const inputProps = {
      placeholder: 'What are you looking for? (e.g. how to start)',
      value,
      onBlur: this.onBlur,
      onChange: this.onChange,
      onKeyDown: this.onKeyDown,
      onKeyPress: this.handleKeyPress
    }

    // doing map, because otherwise in the dynamic segment search the displayed keyword lags by one letter
    let suggestions = this.props.suggestions
    suggestions = suggestions.map(s => ({appName: s.appName,
      callback: s.callback,
      description: s.description,
      icon: s.icon,
      id: s.id,
      params: s.params,
      screen: s.screen,
      title: s.title }))

    return (
      <div className='infra-global-search-autosuggest_wrapper'>
        <img className='infra-global-search-icon' src={require('../../../style/images/icon_search-on-spotlight.png')} />
        <Autosuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          getSuggestionValue={this.getSuggestionValue}
          renderSuggestion={this.renderSuggestion}
          inputProps={inputProps}
          ref={this.storeInputReference}
          alwaysRenderSuggestions
        />
      </div>
    )
  }
}

export default SearchBox

SearchBox.propTypes = {
  closeSearch: React.PropTypes.func,
  onSuggestionsClearRequested: React.PropTypes.func,
  googleAnalytics: React.PropTypes.func,
  requestSuggestions: React.PropTypes.func,
  debounce: React.PropTypes.number
}



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/SearchBox/index.js